/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:54:10 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const updateSubscriptionTierMutation = gql`
  mutation UpdateSubscriptionTier(
    $id: ID!
    $name: String
    $monthlyCost: MoneyInput
    $annualCost: MoneyInput
    $freeTrialDuration: NonNegativeInt
    $maximumEmployees: NonNegativeInt
    $maximumSubcontractors: NonNegativeInt
    $maximumProjects: NonNegativeInt
    $capabilities: [ID!]
    $isCustomTier: Boolean
    $customOrganisationsIds: [ID!]
  ) {
    data: updateSubscriptionTier(
      id: $id
      name: $name
      monthlyCost: $monthlyCost
      annualCost: $annualCost
      freeTrialDuration: $freeTrialDuration
      maximumEmployees: $maximumEmployees
      maximumSubcontractors: $maximumSubcontractors
      maximumProjects: $maximumProjects
      capabilities: $capabilities
      isCustomTier: $isCustomTier
      customOrganisationsIds: $customOrganisationsIds
    ) {
      id
      name
      monthlyPlan {
        cost {
          currencyCode
          amount
        }
      }
      annualPlan {
        cost {
          currencyCode
          amount
        }
      }
      isFreeTier
      isCustomTier
      isInitialTier
      customOrganisationsIds
      freeTrialDuration
      maximumEmployees
      maximumSubcontractors
      maximumProjects
      capabilities {
        id
        description
        enabled
      }
      statistics {
        monthlySubscribers
        annualSubscribers
        freeSubscribers
      }
    }
  }
`;

export default ({ client, params }) => {
  try {
    if (params.data.isFreeTier) {
      // DEPRECIATED: backend validation accepts null monthly costs & annual costs 
      // params.data.monthlyCost = { currencyCode: 'GBP', amount: '0.0' }; 
      // params.data.annualCost = { currencyCode: 'GBP', amount: '0.0' };
    } else {
      params.data.monthlyCost = params.data.monthlyPlan.cost;
      params.data.annualCost = params.data.annualPlan.cost;
    }
    params.data.capabilities = params.data.capabilities
      .filter(capability => capability.enabled)
      .map(enabledCapability => enabledCapability.id); //only send ids of enabled permissiosn
    return client.mutate({
      mutation: updateSubscriptionTierMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
